/* TrueForm Theme JS */
(() => {
  'use strict';

  /* ─── Mobile Menu ─── */
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileMenu.classList.remove('open')));
  }

  /* ─── Scroll Reveal ─── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
    }, { threshold: 0.12 });
    revealEls.forEach(el => observer.observe(el));
  }

  /* ─── Cart Drawer ─── */
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  const cartCount = document.querySelectorAll('.cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.getElementById('cartClose')?.addEventListener('click', closeCart);
  document.querySelectorAll('[data-open-cart]').forEach(btn => btn.addEventListener('click', openCart));

  function updateCartCount(count) {
    cartCount.forEach(el => { el.textContent = count; el.style.display = count > 0 ? 'inline-flex' : 'none'; });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCartItems(items) {
    const body = document.getElementById('cartBody');
    const subtotalEl = document.getElementById('cartSubtotal');
    if (!body) return;

    if (!items || items.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      if (subtotalEl) subtotalEl.textContent = '$0.00';
      return;
    }

    body.innerHTML = items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__img" src="${item.image || ''}" alt="${item.product_title}">
        <div class="cart-item__details">
          <div class="cart-item__name">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price-row">
            <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
            <div class="cart-item__qty">
              <button class="qty-dec" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button class="qty-inc" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
            </div>
          </div>
        </div>
      </div>
    `).join('');

    body.querySelectorAll('.qty-dec, .qty-inc').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderCartItems(cart.items);
        updateCartCount(cart.item_count);
        const subtotalEl = document.getElementById('cartSubtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(console.error);
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        renderCartItems(cart.items);
        updateCartCount(cart.item_count);
        const subtotalEl = document.getElementById('cartSubtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(console.error);
  }

  /* ─── Quick Add to Cart ─── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.textContent = 'ADDING...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'ADDED ✓';
        setTimeout(() => { btn.textContent = 'QUICK ADD'; btn.disabled = false; }, 2000);
        openCart();
      })
      .catch(() => { btn.textContent = 'QUICK ADD'; btn.disabled = false; });
  });

  /* ─── Product Page: Add to Cart Form ─── */
  const productForm = document.getElementById('productForm');
  if (productForm) {
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      const btn = productForm.querySelector('.add-to-cart-btn');
      const variantId = productForm.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      const original = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'ADDED TO BAG ✓';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
          openCart();
        })
        .catch(() => { btn.textContent = original; btn.disabled = false; });
    });

    /* Size selection */
    productForm.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        productForm.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        const variantInput = productForm.querySelector('[name="id"]');
        if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
      });
    });
  }

  /* ─── Product Gallery Thumbnails ─── */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const main = document.getElementById('mainProductImg');
      if (main && src) main.src = src;
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ─── Newsletter Form ─── */
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]')?.value;
      const btn = form.querySelector('button');
      if (!email) return;
      btn.textContent = 'SUBSCRIBED ✓';
      form.querySelector('input[type="email"]').value = '';
      setTimeout(() => btn.textContent = 'SUBSCRIBE', 3000);
    });
  });

  /* ─── Init ─── */
  refreshCart();
})();
